import React, { useEffect, useRef, useState } from "react";
import API from "util/Api";
import { Formik } from "formik";
import SnackBar from "components/SnackBar";
import { Form, connect } from "formik";
import { Button, Box } from "@material-ui/core";
import FormField from "components/FormField";
import ContainerHeader from "components/ContainerHeader";
import _ from "lodash";
import CardBox from "components/CardBox";
import * as Yup from "yup";
import SimpleTable from "components/ActionsTable/SimpleTable";
import { decrypt } from "util/secure";
import moment from "moment";
// import dummyData from "./dummy";

const UpdateRateConfig = connect((props) => {
  console.log('rate-config-props', props);
  const [fields, setFields] = useState(props.section.fields);
  const fieldsRef = useRef(fields);

  useEffect(() => {
    fieldsRef.current = fields;
  }, [fields]);
  
  useEffect(()=>{
    let fieldsClone = _.cloneDeep(props.section.fields);
    fieldsClone.vehicle_type_id.options = _.filter(props.section.fields.vehicle_type_id.options, { 'location_id': props.formik.values.location_id?.value });
    fieldsClone.rate_model_id.options = _.filter(props.section.fields.rate_model_id.options, {'location_id': props.formik.values.location_id?.value, 'vehicle_type_id': props.formik.values.vehicle_type_id });
    setFields(fieldsClone);
    props.formik.setFieldValue('rate_model_id',"");
  },[props.formik.values.location_id, props.formik.values.vehicle_type_id])
  
	var barcodeBuffer=''
	var timer = null
	function handleExtQRScan(e){

			// Most scanners don't send Shift/Alt/Ctrl/meta keys
			if(e?.key?.length === 1) {
				
				barcodeBuffer += e.key;
				// Reset timer each keystroke
				if (timer) clearTimeout(timer);
		
				timer = setTimeout(() => {
					barcodeBuffer='';
				}, 1000); // Wait max 100ms between keys (scanner is fast)

			}else if(e?.key === 'Enter') {
				props.formik.setFieldValue("update_key","")
				try{
					// End of scan
					console.log('Scanned barcode:', barcodeBuffer);
					let decrypted = decrypt(barcodeBuffer).split("/")
					let day = moment.unix(decrypted[2]).format("YYMMDD")
					let text = day+decrypted[4]+decrypted[5];
					props.formik.setFieldValue("update_key",text)
          //setting vehicle type here
          let vehType = _.find(fieldsRef?.current?.vehicle_type_id?.options,{title:decrypted[1]})
          
          if(vehType)
            props.formik.setFieldValue("vehicle_type_id",vehType.value)
					
          barcodeBuffer=''
				}catch{
					console.log("handle error here")
					barcodeBuffer='';
				}
				
			}
		
	}
	useEffect(()=>{
		
		document.addEventListener('keydown',handleExtQRScan);   
		return () => {
			document.removeEventListener("keydown", handleExtQRScan);
		};
	},[])

	return (
		<div className="row">
		<CardBox styleName="col-12">
			<Form>
			{/* FIRST ROW */}
			<div className="row">
				{Object.values(fields).map((field) => (
				field && (!field.dependency || field.dependencyValue == props.formik.values[field.dependency]) &&
				<div className="col-md-3 col-12" key={`field-${field.key}`}>
					<FormField field={{ ...field, ...{ name: field.key } }} />
				</div>
				))}
			</div>
			{/* BUTTONS */}
			<div className="row mt-2">
				<div className="col-lg-6 col-sm-12 col-12">
				<Box mt="20px">
					<Box mr="10px" display="inline">
					<Button
						variant="contained"
						color="primary"
						mr="5px"
						type="submit"
					>
						{` Update `}
					</Button>
					</Box>
					<Box mr="10px" display="inline">
					<Button variant="outlined" color="secondary" type="reset">
						Reset
					</Button>
					</Box>
				</Box>
				</div>
			</div>
			</Form>
		</CardBox>
		</div>
	);
});

const UpdateRateModel = (props) => {
	const [config, setConfig] = useState(null);
	const [initialValues, setInitialValues] = useState();
	const [activeParking, setActiveParkings] = useState();
	const [newRateActiveParkings, setNewRateActiveParkings] = useState();
	const [snackBar, setSnackBar] = useState({
		open: false,
		message: "",
		type: "error",
	});

  const validations = Yup.object().shape({
    location_id: Yup.object().required("Required"),
    vehicle_type_id: Yup.string().required("Required"),
    update_key: Yup.string().required("Required"),
    rate_model_id: Yup.string().required("Required"),
  });

  const update = (data, form) => {
    API.put("parkingRate", JSON.stringify(data))
      .then((res) => {
        form.setSubmitting(false);
        form.resetForm();
        setActiveParkings(undefined);
        getUpdateRate()
        setSnackBar({
          open: true,
          message: res.data.msg,
          type: "success",
        });
      }).catch((err) => {
        console.log("error", err);
        form.setSubmitting(false);
        setActiveParkings(err?.response?.data?.data);
        setSnackBar({
          open: true,
          message: err?.response?.data?.msg ? err.response.data.msg : "Something went wrong",
          type: "error",
        });
      });
  };
  const getUpdateRate = (list=false) =>{
	API.get(`parkingRate`).then((res) => {
		setConfig(res.data.data.config);
		setInitialValues(res.data.data.config.values);
        setNewRateActiveParkings(res.data.data.activeParkings);
    }).catch((err) => {
        setSnackBar({
			open: true,
			message: err?.response?.data?.msg ? err.response.data.msg : "Something went wrong",
			type: "error",
        });
    });
  }
  useEffect(() => {
    getUpdateRate()
  }, []);

  const handleReset = () => {
    setActiveParkings();
  }
  
  return (
    <>
      {config && <ContainerHeader
        title={config.title}
        match={props.match}
      />}
      {config && initialValues && (
        <Formik
          onSubmit={update}
          initialValues={initialValues}
          validationSchema={validations}
          onReset={handleReset}
        >
          <UpdateRateConfig section={config} />
        </Formik>
      )}

      {activeParking && (
      <CardBox
        styleName={"col-12"} cardStyle="p-0"
      >
        <SimpleTable
          // tableHeading={activeParking.title}
          table={activeParking}
          editRateModel={() => { }}
        />
      </CardBox>
      )}

      {newRateActiveParkings &&
      <CardBox
        styleName={"col-12"} cardStyle="p-0" 
        headerOutside
        heading={"Requested Rate Update"}
      >
        <SimpleTable
          table={newRateActiveParkings}
        />      
      </CardBox>       
      }
      <SnackBar
        {...snackBar}
        handleClose={() => {
          setSnackBar({ open: false, message: "" });
        }}
      />
    </>
  );
};
export default UpdateRateModel;
